import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export const PermisosAuth = ({
  children,
  perfilesPermitidos = [],
  redireccion,
}) => {
  const { valida, isAuthenticated, roles } = useSelector(
    (state: RootState) => state.ui
  );
  if (valida) {
    return <div>Cargando...</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }
  if (perfilesPermitidos.length > 0) {
    const tienePermiso = roles.some((rol) => perfilesPermitidos.includes(rol));
    if (!tienePermiso) {
      return <Navigate to={redireccion} replace />;
    }
  }
  return children;
};
